/**
 * Tooltip — Formula explanations from backend via ConfigContext.
 * No local imports from engine files.
 */
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { useConfig } from '../context/ConfigContext';

export function ValueWithTooltip({ children, fieldKey, className = "" }) {
  const { formulas } = useConfig();
  const e = formulas[fieldKey];
  if (!e) return <span className={className}>{children}</span>;
  return (
    <TooltipProvider delayDuration={80}>
      <Tooltip>
        <TooltipTrigger asChild><span className={`cursor-help ${className}`}>{children}</span></TooltipTrigger>
        <TooltipContent side="top" className="max-w-[200px] bg-gray-900 text-white border-0 p-1.5 rounded text-[9px]">
          <div className="font-medium">{e.label}</div>
          <div className="text-gray-400 text-[8px]">{e.description}</div>
          <div className="mt-1 pt-1 border-t border-gray-700">
            <div className="text-blue-300 text-[8px]">Formula: {e.formula}</div>
            <div className="text-gray-500 text-[8px]">Base: {e.base}</div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function LabelWithTooltip({ fieldKey, children }) {
  const { formulas } = useConfig();
  const e = formulas[fieldKey];
  if (!e) return children;
  return (
    <TooltipProvider delayDuration={80}>
      <Tooltip>
        <TooltipTrigger asChild><span className="cursor-help">{children}</span></TooltipTrigger>
        <TooltipContent side="right" className="max-w-[180px] bg-gray-900 text-white border-0 p-1.5 rounded text-[9px]">
          <div className="font-medium">{e.label}</div>
          <div className="text-gray-400 text-[8px]">{e.description}</div>
          <div className="text-gray-500 text-[8px] mt-0.5">Base: {e.base}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
